import * as React from 'react';

export const header = {
  heading: 'Information For Applicants '
};
export const richText1 = {
  id: 'InformationForApplicants',
  html:
    '                <p>This section describes how we collect and share information in connection with your application for employment. \n'
    + '                 The above sections of this Privacy and Security Statement do not apply to our processing of applicant information.</p> \n'
    + '              <p>We collect the following categories of personal information in association with your application for employment with us: </p>\n'
    + '              <p><br/></p> \n'
    + '              <p>Identifiers: such as your name, email address, phone numbers, username, online identifier, device identifier, IP address,\n'
    + '                 social media handle, physical address, and government-issued identifiers.</p>\n'
    + '              <p><br/></p> \n'
    + '              <p>Demographics: such as your date and place of birth; age; gender; nationality; native language; family and marital status; \n'
    + '                 veteran status; details of family members and dependents (name, date of birth, relationship to applicant or candidate); and emergency contact name,\n'
    + '                 address and telephone number.</p>\n'
    + '              <p><br/></p> \n'
    + '              <p>Information regarding eligibility to work: such as passport or visa information.</p>\n'
    + '              <p><br/></p> \n'
    + '              <p>Financial information:  certain financial or banking information.</p>\n'
    + '              <p><br/></p> \n'
    + '              <p>Work history: such as position/title; location; work address; start and end-dates of employment;\n'
    + '                 contact information for former employer(s) or other persons or entities for which work was performed; business unit; function; organizational unit;\n'
    + '                 dates and reasons for hire, promotion, transfer, status change and termination; employment status (full-time or part-time); employment type; \n'
    + '                 job performance and related evaluative information; information relating to awards, certifications, and professional associations and volunteer activities; language proficiency; skills.</p>\n'
    + '              <p><br/></p> \n'
    + '              <p>Education information:  such as education level, training, development, professional degrees, and certificates. </p>\n'
    + '              <p><br/></p> \n'
    + '              <p>Inferences and other characteristics:  such as any observations we may make based on your application or interview, and information provided by your references.\n'
    + '                 We use the information we collect for the following purposes:</p>\n'
    + '              <p><br/></p> \n'
    + '              <ul> \n'
    + '              <li>Processing your application</li>\n'
    + '              <li>Evaluating your qualifications</li>\n'
    + '              <li>Administering and managing our recruitment processes</li>\n'
    + '              <li>Managing payroll and compensation</li>\n'
    + '              <li>Developing financial and employment metrics</li>\n'
    + '              <li>Budgeting, forecasting, and reporting</li>\n'
    + '              <li>Monitoring and complying with legal requirements</li>\n'
    + '              <li>Responding to internal or external audits and inquiries, law enforcement requests, or requests from administrative or judicial authorities</li>\n'
    + '              <li>Monitoring and promoting compliance with our policies and procedures </li>\n'
    + '              <li>Security</li>\n'
    + '              </ul> \n'
    + '              <p><br/></p> \n'
    + '              <p>If you provide us with personal information about members of your family and/or other dependents (e.g., for emergency contact),\n'
    + '                 it is your responsibility to provide them with the information contained in this section. </p>\n'
};
